// src/navigation/utils.ts
const HTTP_HREF_PREFIXES = [
	"//",
	"http://",
	"https://"
];
const APP_HANDOFF_HREF_PREFIXES = ["mailto:", "tel:"];
const EXTERNAL_HREF_PREFIXES = [...HTTP_HREF_PREFIXES, ...APP_HANDOFF_HREF_PREFIXES];
const isAppHandoffHref = (href) => APP_HANDOFF_HREF_PREFIXES.some((prefix) => href.startsWith(prefix));
/**
* Narrows an href to the same-origin shapes covered by {@link InternalHref}:
* an absolute path, a bare fragment, or a bare query string.
*/
const isInternalHref = (href) => {
	if (href.startsWith("//")) return false;
	else return href.startsWith("/") || href.startsWith("#") || href.startsWith("?");
};
/**
* Narrows an href to the cross-origin shapes covered by {@link ExternalHref}.
*/
const isExternalHref = (href) => EXTERNAL_HREF_PREFIXES.some((prefix) => href.startsWith(prefix));
/**
* Narrows an href to the cross-origin shapes covered by {@link HttpHref}:
* {@link isExternalHref} without the app handoffs.
*/
const isHttpHref = (href) => HTTP_HREF_PREFIXES.some((prefix) => href.startsWith(prefix));
const getDestinationTypeAwareLinkProps = ({ href, isOriginAware = true }) => {
	if (isHttpHref(href)) return {
		target: "_blank",
		rel: isOriginAware ? "noopener" : "noopener noreferrer"
	};
	else return {};
};
/**
* Returns the current `window.location` object on the client, or `null` otherwise.
*/
const getWindowLocation = () => typeof window === "undefined" ? null : window.location;
export { getDestinationTypeAwareLinkProps, getWindowLocation, isAppHandoffHref, isExternalHref, isHttpHref, isInternalHref };

//# sourceMappingURL=utils.js.map